export const formatDate = (dateString, showTime = false) => {
  if (!dateString) return '-';

  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  const dateFormatted = `${day}-${month}-${year}`;

  if (!showTime) return dateFormatted;

  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${dateFormatted} à ${hours}h${minutes}`;
};
